import { CallbackError, ReadCallback } from "i18next";
import { default as Backend, HttpBackendOptions } from "i18next-http-backend";

interface ILoadBackendTranslationsOptions extends HttpBackendOptions {
  insufficientPermissionsFallback: () => void;
}

export class HttpBackendTranslationLoader extends Backend {
  override options: ILoadBackendTranslationsOptions;

  constructor(services: any, options: ILoadBackendTranslationsOptions) {
    super(services, options);
    this.options = options;
  }

  override read(language: string, namespace: string, callback: ReadCallback): void {
    super.read(language, namespace, (error: CallbackError, data: any) => {
      if (error) {
        console.error(`Failed loading backend translations: ${language}/${namespace}`, error);

        if (error.toString().includes("403")) {
          // Handle the case where locale fallback translations have been loaded
          this.options.insufficientPermissionsFallback();
        }
      }

      callback(error, data);
    });
  }
}
